(function () {
    'ngInject';

    angular.module('app.shared.services').factory('LibrariesUtilService', librariesUtils);

    function librariesUtils($q, $mdDialog, LibrariesAPIService) {
        var pickerSettings = {
            libraryType: 'color'
        };
        var showingDialog = false;

        function getCurrentPickerSettings() {
            if (showingDialog) {
                return pickerSettings;
            } else {
                return null;
            }
        }

        function showLibraryPicker(type) {
            return $q(function (resolve) {
                showingDialog = true;
                pickerSettings.libraryType = type;

                $mdDialog
                    .show({
                        template: require('../../../../views/pages/libraries/libraries.html'),
                        parent: angular.element(document.body),
                        clickOutsideToClose: true
                    })
                    .then(
                        function (data) {
                            showingDialog = false;
                            resolve(data);
                        },
                        function () {
                            showingDialog = false;
                            resolve();
                        }
                    );
            });
        }

        function showColorLibraryPicker() {
            return showLibraryPicker('color');
        }

        function showFontLibraryPicker() {
            return showLibraryPicker('font');
        }

        function showVectorLibraryPicker() {
            return showLibraryPicker('vector');
        }

        function showImageLibraryPicker() {
            return showLibraryPicker('image');
        }

        /**
         * Update the library name for the given element in the given controller scope
         * @param {object} $scope Step 1 or Step 2 controller scope
         * @param {object} element fabric.js object
         */
        function updateLibraryNames($scope, element) {
            if (element.fontLibraryId) {
                LibrariesAPIService.getLibraryName(element.fontLibraryId).then(function (name) {
                    $scope.selectedFontLibraryName = name;
                });
            }

            if (element.colorLibraryId) {
                LibrariesAPIService.getLibraryName(element.colorLibraryId).then(function (name) {
                    $scope.selectedColorLibraryName = name;
                });
            }

            if (element.imageLibraryId) {
                LibrariesAPIService.getLibraryName(element.imageLibraryId).then(function (name) {
                    $scope.selectedImageLibraryName = name;
                });
            }

            if (element.vectorLibraryId) {
                LibrariesAPIService.getLibraryName(element.vectorLibraryId).then(function (name) {
                    $scope.selectedVectorLibraryName = name;
                });
            }
        }

        return {
            showColorLibraryPicker: showColorLibraryPicker,
            getCurrentPickerSettings: getCurrentPickerSettings,
            showFontLibraryPicker: showFontLibraryPicker,
            showVectorLibraryPicker: showVectorLibraryPicker,
            showImageLibraryPicker: showImageLibraryPicker,
            updateLibraryNames: updateLibraryNames
        };
    }
})();
